import { render, staticRenderFns } from "./warn_record_list.vue?vue&type=template&id=59f6ea12&scoped=true"
import script from "./warn_record_list.vue?vue&type=script&lang=js"
export * from "./warn_record_list.vue?vue&type=script&lang=js"
import style0 from "./warn_record_list.vue?vue&type=style&index=0&id=59f6ea12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f6ea12",
  null
  
)

export default component.exports